module.exports = __webpack_public_path__ + "static/img/background.b9a0abdb40.png";